// extracted by mini-css-extract-plugin
module.exports = {"label":"NewsletterContact_label__K2tQ3","form":"NewsletterContact_form___i_DB","fieldsWrapper":"NewsletterContact_fieldsWrapper__cazIz","field":"NewsletterContact_field__E3D3G"};